export default {

  MAX_ATTACHMENT_SIZE: 20000000,
  s3: {
    REGION: "ap-south-1",
    BUCKET: "retnetindiadev-blog-uploads"
  },
  apiGateway: {
    REGION: "ap-south-1",
    // URL: "https://yuya3938ii.execute-api.us-east-1.amazonaws.com/prod"
    URL: "https://81ai6qs5sj.execute-api.ap-south-1.amazonaws.com/prod"
  },
  cognito: {
    REGION: "ap-south-1",
    USER_POOL_ID: "ap-south-1_bp5Zgo9YN",
    APP_CLIENT_ID: "58a926rf3n8lrtdkksf9o6mkev",
    IDENTITY_POOL_ID: "ap-south-1:4844f78e-1968-49e1-969d-9b7c8eb17b32"
  }


};



// WEBPACK FOOTER //
// ./src/config.js